<template>
    <div></div>
</template>

<script>
// import x from ''
export default {
    name: 'interfaceService',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang='scss' scoped>
</style>
